import { type TooltipPlacement } from 'antd/lib/tooltip';
import { type AlignType } from 'rc-trigger/lib/interface';
import { type MouseEvent, useState } from 'react';

import { Tooltip } from 'components/ui';

import { TooltipTitle } from './OverlayTooltip.style';

type OverlayTooltipProps = {
  children: JSX.Element;
  imagePaneBox?: DOMRect;
  isNewFullSizeImageViewer?: boolean;
  title?: React.ReactNode;
};

const DEFAULT_ALIGNMENT: AlignType = {
  targetOffset: [-50],
  useCssBottom: true,
};

export const OverlayTooltip = ({
  children,
  imagePaneBox,
  isNewFullSizeImageViewer,
  title,
}: OverlayTooltipProps) => {
  const [placement, setPlacement] = useState<TooltipPlacement>('top');

  const handleMouseEnter = ({ target }: MouseEvent<HTMLElement | SVGElement>) => {
    if (!target || !imagePaneBox) {
      return;
    }

    const box = (target as SVGElement).getBoundingClientRect();
    const horizontalCenter = (box.left + box.right) / 2;

    if (horizontalCenter < imagePaneBox.left) {
      setPlacement('right');
    } else if (horizontalCenter > imagePaneBox.right) {
      setPlacement('left');
    } else {
      setPlacement('top');
    }
  };

  const positioningProps = isNewFullSizeImageViewer
    ? {
        placement,
        onMouseEnter: handleMouseEnter,
      }
    : {
        align: DEFAULT_ALIGNMENT,
      };

  return (
    <Tooltip title={title ? <TooltipTitle>{title}</TooltipTitle> : undefined} {...positioningProps}>
      {children}
    </Tooltip>
  );
};
